import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import Minibar from '../../../components/navbar/Minibar.js';
import HistoricalDataPerformance from '../../../components/history/HistoricalDataPerformance.js';
import HistoricalDataProduction from '../../../components/history/HistoricalDataProduction.js';
import HistoricalDataInverterPower from '../../../components/history/HistoricalDataInverterPower.js';
import HistoricalDataEnvironment from '../../../components/history/HistoricalDataEnvironment.js';
import HistoricalDataRawDataTable from '../../../components/history/HistoricalDataRawDataTable.js';
import HistoricalDataRawDataCustom from '../../../components/history/HistoricalDataRawDataCustom.js';
import HistoricalDataENSValidation from '../../../components/history/HistoricalDataENSValidation.js';
import HistoricalDataEnergyCross from '../../../components/history/HistoricalDataEnergyCross.js';
import './historical_rawdata.css';

function HistoricalData(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('-');

    useEffect(() => {
        if (location.pathname.search("/historical/historicaldata/performance") > -1) {
            setSubmenu_root('Performance')
        }
        if (location.pathname.search("/historical/historicaldata/production") > -1) {
            setSubmenu_root('Production')
        }
        if (location.pathname.search("/historical/historicaldata/inverterpower") > -1) {
            setSubmenu_root('Inverter Power')
        }
        if (location.pathname.search("/historical/historicaldata/environment") > -1) {
            setSubmenu_root('Environment')
        }
        if (location.pathname.search("/historical/historicaldata/rawdata") > -1) {
            setSubmenu_root('Raw Data Table')
        }
        if (location.pathname.search("/historical/historicaldata/ensvalidation") > -1) {
            setSubmenu_root('ENS Validation')
        }
        if (location.pathname.search("/historical/historicaldata/energycross") > -1) {
            setSubmenu_root('Energy Cross Period')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Historical Tracking"}
                submenu_root={"Historical Data"}
                submenu_root2={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <Routes>
                        <Route path="/performance"
                            element={
                                <HistoricalDataPerformance
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataPerformance>} />
                        <Route path="/production"
                            element={
                                <HistoricalDataProduction
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataProduction>} />
                        <Route path="/inverterpower"
                            element={
                                <HistoricalDataInverterPower
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    data_uioption={props.data_uioption}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataInverterPower>} />
                        <Route path="/environment"
                            element={
                                <HistoricalDataEnvironment
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataEnvironment>} />
                        <Route path="/rawdata"
                            element={
                                <HistoricalDataRawDataTable
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    data_uioption={props.data_uioption}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataRawDataTable>} />
                        <Route path="/rawcustom"
                            element={
                                <HistoricalDataRawDataCustom
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataRawDataCustom>} />
                        <Route path="/ensvalidation"
                            element={
                                <HistoricalDataENSValidation
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    data_uioption={props.data_uioption}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataENSValidation>} />
                        <Route path="/energycross"
                            element={
                                <HistoricalDataEnergyCross
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={false}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></HistoricalDataEnergyCross>} />
                    </Routes>
                </div>
            </div>
        </section>
    )
}
export default HistoricalData